export const OPERATORS = {
  BETWEEN: 'bt',
  EQUALS: '=',
  GREATER_THAN: '>',
  LESS_THAN: '<',
  IN: 'in',
  LIKE: 'like'
};

export const FILTER_CATEGORIES = {
  DRAFT: 'draft',
  PLAYER: 'player',
  STATS: 'stats',
  COMBINE: 'combine',
};

export const EVENT_NAMES = {
  FILTER_ADDED: 'filterAdded',
  FILTER_REMOVED: 'filterRemoved',
  QUERY_SUBMITTED: 'querySubmitted',
  COPY_LINK_CLICKED: 'copyQueryLink',
  RESET: 'resetQuery',
};
